import { jsx } from "react/jsx-runtime";
const Flag2 = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 .707 1.707L15.914 9.5l3.793 3.793A1 1 0 0 1 19 15H6v6a1 1 0 1 1-2 0V5Zm2 8h10.586l-2.793-2.793a1 1 0 0 1 0-1.414L16.586 6H6v7Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const Flag2_Flag2 = Flag2;
export default Flag2_Flag2;
